import { authHeaders, logout, getToken } from './admin-auth.js';
import { updateState, catalog, selectedChannel } from './admin-globals.js';

/**
 * @param {{ channelId?: string, channelIndex?: number }} [options]
 *   channelId: mantener selección por id tras recargar (p. ej. tras biblioteca/playlist)
 */
export async function loadCatalog(options = {}) {
  const preserveId = options.channelId ?? catalog[selectedChannel]?.id ?? null;
  const preserveIndex =
    options.channelIndex !== undefined ? options.channelIndex : selectedChannel;

  try {
    const res = await fetch('/channels', { headers: authHeaders() });
    if (!res.ok) {
      if (res.status === 401 && getToken()) {
        console.warn('Sesión caducada o token inválido.');
        logout();
      }
      return;
    }
    const data = await res.json();
    updateState('catalog', data);

    const m = await import('./catalog-ui.js');
    m.renderSidebar();
    if (data.length > 0) {
      let idx = 0;
      if (preserveId) {
        const byId = data.findIndex((c) => c.id === preserveId);
        if (byId >= 0) idx = byId;
      } else if (
        typeof preserveIndex === 'number' &&
        preserveIndex >= 0 &&
        preserveIndex < data.length
      ) {
        idx = preserveIndex;
      }
      m.selectChannel(idx);
    }
  } catch (e) {
    console.error('Error al cargar catálogo:', e);
  }
}

export async function saveChannel(channel) {
  try {
    const res = await fetch(`/channels/${channel.id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(channel),
    });
    return res.ok;
  } catch (e) {
    return false;
  }
}
